import { jsxs as d, jsx as i, Fragment as l } from "react/jsx-runtime";
import { clsx as r } from "../../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import e from "./roche-diagnostics-legend.module.scss.js";
const p = { h2: "h3", h3: "h4", h4: "h5", h5: "h6" }, v = ({
  heading: t,
  entries: _,
  footnoteLabel: o,
  notesHeading: c,
  notes: h = [],
  headlineLevel: g = "h4"
}) => {
  const m = p[g];
  return /* @__PURE__ */ d("div", { className: e["diagnostics-legend"], children: [
    /* @__PURE__ */ i(g, { className: e["diagnostics-legend__heading"], children: t }),
    /* @__PURE__ */ i("dl", { className: e["diagnostics-legend__list"], children: _.map(({ footnote: n, term: s, description: a }) => /* @__PURE__ */ d("div", { className: e["diagnostics-legend__entry"], children: [
      /* @__PURE__ */ d("dt", { className: e["diagnostics-legend__term"], children: [
        n !== void 0 && /* @__PURE__ */ d(l, { children: [
          /* @__PURE__ */ i("sup", { className: e["diagnostics-legend__footnote"], "aria-hidden": "true", children: n }),
          /* @__PURE__ */ i("span", { className: e["diagnostics-legend__visually-hidden"], children: `${o} ${n}${s ? "," : ""}` })
        ] }),
        s && /* @__PURE__ */ d(l, { children: [
          " ",
          s
        ] })
      ] }),
      /* @__PURE__ */ i(
        "dd",
        {
          className: r(
            e["diagnostics-legend__description"],
            s && e["diagnostics-legend__description--after-term"]
          ),
          children: a
        }
      )
    ] }, `${n ?? ""}${s ?? a}`)) }),
    c && h.length > 0 && /* @__PURE__ */ d(l, { children: [
      /* @__PURE__ */ i(m, { className: e["diagnostics-legend__heading"], children: c }),
      h.map(({ variants: n, text: s }) => /* @__PURE__ */ d("p", { className: e["diagnostics-legend__note"], children: [
        /* @__PURE__ */ i("span", { className: e["diagnostics-legend__swatches"], "aria-hidden": "true", children: n.map((a) => /* @__PURE__ */ i(
          "span",
          {
            className: r(
              e["diagnostics-legend__swatch"],
              e[`diagnostics-legend__swatch--${a}`]
            )
          },
          a
        )) }),
        s
      ] }, s))
    ] })
  ] });
};
export {
  v as RocheUIDiagnosticsLegend
};
